import { alertConstants } from "../_constants";

export function alert(state = {}, action) {
    switch (action.type) {
        case alertConstants.LOADING:
            return {
                type: alertConstants.LOADING,
                message: action.message,
                showCloseBtn: false,
                autoHide: false,
                tapOutsideToClose: false
            };
        case alertConstants.SUCCESS:
            return {
                type: "alert-success",
                message: action.message
            };
        case alertConstants.ERROR:
            return {
                type: "alert-danger",
                message: action.message
            };
        case alertConstants.CLEAR:
            return {};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/alert.reducer.js